<div class="flex flex-column gap pt-3">
    <div class="flex gap flex-wrap">
        <app-text-input id="name" [form]="form" [prefix]="prefix"></app-text-input>
        <app-select-input id="type" [form]="form" [prefix]="prefix"
            [staticOptions]="socialServiceOperationEnumOptions"></app-select-input>

        <app-select-input id="billCode" [form]="form" [prefix]="prefix" class="midLabel"
            [staticOptions]="billCodes"></app-select-input>
        <app-select-input id="facultativeCode" [form]="form" [prefix]="prefix" class="midLabel"
            [staticOptions]="socialServiceFacultativeCodeEnumOptions"></app-select-input>
        <app-select-input id="informationCode" [form]="form" [prefix]="prefix" class="midLabel"
            [staticOptions]="socialServiceInformativeCodeEnumOptions"></app-select-input>
        <app-select-input id="unit" [form]="form" [prefix]="prefix" [staticOptions]="measurementUnitEnumOptions"
            class="midLabel"></app-select-input>
        <app-select-input id="payment" [form]="form" [prefix]="prefix"
            [staticOptions]="socialServiceOperationPaymentEnumOptions"></app-select-input>

        <app-text-input id="maxPrice" [form]="form" [prefix]="prefix" class="midLabel"></app-text-input>
        <app-text-input id="maxPriceExt" [form]="form" [prefix]="prefix" class="longLabel"></app-text-input>
        <app-date-input id="validFrom" [form]="form" [prefix]="prefix"></app-date-input>
        <app-date-input id="validTo" [form]="form" [prefix]="prefix"></app-date-input>

        <app-check-input id="mpsvBasic" [form]="form" [prefix]="prefix"></app-check-input>
        <app-check-input id="mpsvMeeting" [form]="form" [prefix]="prefix"></app-check-input>
        <app-check-input id="noRecord" [form]="form" [prefix]="prefix"></app-check-input>
    </div>

    <div class="flex gap align-items-start">
        <app-text-area-input id="description" [form]="form"
            [label]="prefix + 'fields.description'"
        ></app-text-area-input>
    </div>

    @if (operation()) {
        <app-table
            [tableTitle]="'serviceType.operation.procedure.labelMulti'"
            #procedureTable
            [translatePrefix]="procedurePrefix"
            [additionalFilter]="procedureFilter()"
            [columns]="columns"
            [refreshCallback]="store.api.getSocialServiceOperationProcedures"
            [refreshCallbackFragment]="getSocialServiceOperationProcedureFrag"
            [gridData]="store.data.getSocialServiceOperationProcedures()"
            (deleteCallbackWithEvent)="deleteProcedure($event)"
            (createCallback)="upsertProcedure()"
            (detailCallback)="upsertProcedure($event)"
        ></app-table>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    >
        @if (!operation()) {
            <app-button
                label="serviceType.operation.message.saveAndContinue"
                (clickEvent)="save(true)"
            ></app-button>
        }
    </app-action-buttons>
</div>
